import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <h2 className="footer-brand">EarMeOut</h2>
          <p className="footer-mission">
            A nonprofit initiative dedicated to making mental health support accessible to everyone, everywhere.
          </p>
          <div className="footer-social">
            <a
              href="https://www.instagram.com/earmeout.nonprofit/"
              className="footer-social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow EarMeOut on Instagram"
            >
              <svg
                className="footer-social-icon"
                viewBox="0 0 24 24"
                width="22"
                height="22"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
              <span>@earmeout.nonprofit</span>
            </a>
          </div>
        </div>

        <div className="footer-right">
          <nav className="footer-nav">
            <Link to="/events" className="footer-link">Events</Link>
            <Link to="/partners" className="footer-link">Partners</Link>
            <Link to="/privacy" className="footer-link">Privacy</Link>
            <Link to="/terms" className="footer-link">Terms</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </nav>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © 2026 EarMeOut Nonprofit. All rights reserved.
        </p>
        <p className="footer-made-with">
          For mental health awareness.
        </p>
      </div>
    </footer>
  );
};

export default Footer;

